// import {
//     EventsFilterFormPaginated
// } from 'features/events';
// import { useConfirmPaymentBulk } from 'features/transaction_list/use-cases/confirm-payment';
// import { useCreateBooking } from 'features/transaction_list/use-cases/create-booking';
import { formateAmount } from 'features/transaction_list/utills/utiils';
import { usePermissions } from 'features/users';
// import { useNavigate } from 'react-router-dom';
// import { ROUTES } from 'routes/constants';

import UploadDetailsComponentTable from './upload-details-component--table';
import { useState } from 'react';


// type EventsTableProps = {
//     isLoading: boolean;
//     data?: any;
//     tableParams: EventsFilterFormPaginated;
//     updateParams: Dispatch<SetStateAction<EventsFilterFormPaginated>>;
//     refetch: () => void;
//     id: any
// };

export const UploadDetailsTable = ({
    data,
    isLoading,
    tableParams,
    updateParams,
    // id,
    refetch
}: any) => {

    const permissions = usePermissions();
    const [couponAmount] = useState<number>(0);

    const getNestedProperty = (obj: any, path: string) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };
    const currencyName = getNestedProperty(data, 'items.0.participant_list.0.currency_name') || 'KD';
    const eventParticipantDiscountCharge = data?.items ? data?.items[0]?.participant_list.reduce((acc: any, curr: any) => acc + curr.coupon_amount, 0) : 0;
    // console.log(eventParticipantDiscountCharge, ":eventParticipantDiscountCharge")
    const totalDiscount = (eventParticipantDiscountCharge + couponAmount + data?.items[0]?.total_amounts?.item_coupon_code_price || 0) || 0;
    // console.log(totalDiscount, "totalDiscount");
    // const currencyName = data?.items && data?.items[0]?.participant_list[0]?.currency_name;
    const grandTotal = data?.items && data?.items[0]?.total_amounts?.ticket_category_price ? (data.items[0].total_amounts.ticket_category_price + data.items[0].total_amounts.tshirt_price + data.items[0].total_amounts.medal_price + data.items[0].total_amounts.photo_price + data.items[0].total_amounts?.delivery_price + data.items[0].total_amounts?.refund_protect_price - totalDiscount)
        : 0;
    // const paymentStatus = data?.items[0]?.bulk_upload_details?.payment_Status || "";

   
    if (!permissions) return null;

    return (

        <>

            <UploadDetailsComponentTable
                data={data}
                isLoading={isLoading}
                tableParams={tableParams}
                updateParams={updateParams}
                refetch={refetch}
            />
       

            <div className='ttl_list_wrap'>
                <div className='ttl_list_b'>
                    <div className='ttl_list'>
                        <span>Total</span>
                        <span>{formateAmount(data?.items[0].total_amounts?.ticket_category_price)} {currencyName}</span>
                    </div>
                    <div className='ttl_list'>
                        <span>T-shirt Printing</span>
                        <span>{formateAmount(data?.items[0].total_amounts?.tshirt_price)} {currencyName}</span>
                    </div>
                    <div className='ttl_list'>
                        <span>Medal Engraving</span>
                        <span>{formateAmount(data?.items[0].total_amounts?.medal_price)} {currencyName}</span>
                    </div>
                    <div className='ttl_list' style={{ border: 'none' }}>
                        <span>Post Event Photos</span>
                        <span>{formateAmount(data?.items[0].total_amounts?.photo_price)} {currencyName}</span>
                    </div>
                    <div className='ttl_list'>
                        <span>Delivery Price</span>
                        <span>{formateAmount(data?.items[0].total_amounts?.delivery_price)} {currencyName}</span>
                    </div>
                    <div className='ttl_list' style={{ border: 'none' }}>
                        <span>Refund Protect Price</span>
                        <span>{formateAmount(data?.items[0].total_amounts?.refund_protect_price)} {currencyName}</span>
                    </div>


                    <div className='ttl_list' style={{ border: 'none' }}>
                        <span>Total Discount</span>
                        <span>{formateAmount(totalDiscount)} {currencyName}</span>
                    </div>


                    <div className='ttl_list' >
                        <span style={{ fontWeight: 500 }}>Grand Total</span>
                        <span>{formateAmount(grandTotal)} {currencyName}</span>
                    </div>
                </div>


                



            </div>

        </>
    );
};


